var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgUnpublished = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 16,
  height: 16,
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M15 8A7 7 0 1 1 1 8a7 7 0 0 1 14 0Zm-4.649 2.351a.525.525 0 0 1-.742 0L8 8.742l-1.609 1.61a.525.525 0 0 1-.742-.743L7.258 8l-1.61-1.609a.525.525 0 1 1 .743-.742L8 7.257 9.609 5.65a.525.525 0 1 1 .742.742L8.742 8l1.61 1.609a.525.525 0 0 1 0 .742Z",
  fill: "#CF1B21"
})));
export default SvgUnpublished;